import _ from 'lodash';
import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import { addStore } from 'client/shared/react-util';

import Editor from '../editor';
import EditImage from '../edit-image';
import FieldFactory from '../field-factory';

import SongList from './song-list';

@inject('formStore', 'albumsStore', 'artistStore', 'userStore')
@observer
class AlbumForm extends Component {
	constructor (props) {
		super(props);

		const { album, artist, artistStore, userStore } = this.props;

		if (_.isEmpty(album.artistID)) {

			let user = userStore.getLoggedInUser();
			let artist = artistStore.getArtistByUserID(user.id);
			album.artistID = artist.id;
		}
	}

	render () {
		const {
			album,
			albumsStore,
			formStore,
			handleImageCrop
		} = this.props;

		const FieldWithStore = addStore(FieldFactory, {
			formStore,
			item: album
		});

		return (
			<div className='grid-container album-form'>
				<div className="grid-x">
					<div className="cell">
						<h4>New Album</h4>
						<FieldWithStore fieldKey="album.artistID" />
						<FieldWithStore fieldKey="album.artwork" />
					</div>
				</div>

				<div className="grid-x">
					<div className="cell small-8">
						<FieldWithStore fieldKey="album.name" />

						<div className="hfm-field">
							<label>Liner Notes</label>
							<Editor
								onChange={ this.onChange }
								content={ album.linerNotes }
							/>
						</div>
					</div>

					<div className="cell auto">
						<EditImage
							item={ album }
							store={ albumsStore }
							handleImageCrop={ handleImageCrop }
							imgSrc={ album.artworkPath }
						/>
					</div>
				</div>

				<div className="grid-x">
					<div className="cell small-=12">
						<SongList album={ album } />
					</div>
				</div>
			</div>
		);
	}

	@autobind
	onChange (linerNotes) {
		this.props.album.linerNotes = linerNotes;
	}
}

export default AlbumForm;
